/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { getLandingContainer } from "../views/utils/getLandingContainer"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { ILandingSection } from "../data/interfaces"
import { ILandingStore, useLandingStore } from "../data/store"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"



export function useLandingScroll( mode: "scroll" | "section" = "scroll"): number | any {
    const [scroll, setScroll] = useState<number>( 0 )
    const {height} = useScreenSize()
    const landing = useLandingStore((state: ILandingStore) => state.currentLanding)
    const section = useSyncState<ILandingSection | undefined>( landing.sections[0] )
    const onscrollHandler = () =>
        {
            try 
            {
                const lScroll = getLandingContainer().scrollTop     
                setScroll( lScroll ) 
                if(mode === "section") {
                    const sections = landing.sections
                    let sectionI: ILandingSection = sections[0]
                    sections.forEach((section: ILandingSection, i: number) => {
                        const secs  = document.getElementById(`${section.id}`)! 
                        const top   = (secs?.getBoundingClientRect().top) - (height/2)
                        // console.log(section.id, Math.floor(top), Math.floor(lScroll) )
                        if( top < 0) {
                            sectionI = sections[i]
                        }
                    })
                    section.set( sectionI )
                }
            } 
            catch (e) 
            {            
                console.log(e)            
            }
        }

    useEffect(() => {
        const lacont = getLandingContainer()
        lacont.addEventListener("scroll", onscrollHandler)        
        return () => { 
            lacont.removeEventListener("scroll", onscrollHandler) 
        }
    }, [ height ])
    return mode === "section" 
        ?
        {
            scroll,
            section: section.get()
        }
        :
        scroll
}